export interface Address {
  city?: string;
  country?: string;
  postalCode?: string;
  state?: string;
  street?: string;
}

export interface Contact {
  contactPerson?: string;
  phoneNumber?: string;
  phoneNumberCountryCode?: string;
}

export interface Coordinates {
  latitude: number;
  longitude: number;
}

export interface CustomAttribute {
  key: string;
  value?: string;
}

export interface CustomAttributeSet {
  attributes: CustomAttribute[];
  typeName?: string;
}

export interface SearchCriteria {
  address?: Address;
  contact?: Contact;
  coordinates?: Coordinates;
  currency?: string;
  customAttributeSets?: CustomAttributeSet[];
  description?: string;
  enterpriseUnitName?: string;
  group?: string;
  isGrouped?: boolean;
  locked?: boolean;
  parentEnterpriseUnitId?: string;
  siteName?: string;
  status?: Status;
  timeZone?: string;
}

export enum Status {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface Sort {
  column?: string;
  direction?: SortDirection;
}

export enum SortDirection {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

export interface FindByCriteriaRequest {
  criteria?: SearchCriteria;
  customAttributes?: string[];
  fields?: string[];
  sort?: Sort[];
}

export enum Day {
  DAILY = 'DAILY',
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export interface DayPart {
  day: Day;
  description?: string;
  /** 4 characters representing 24hr time */
  endTime?: string;
  name?: string;
  /** 4 characters representing 24hr time */
  startTime: string;
}

export interface TimePeriod {
  day: Day;
  /** 4 characters representing 24hr time */
  time: string;
}

export interface Hours {
  open: TimePeriod;
  close: TimePeriod;
}

export interface ConfigurationSetting {
  key: string;
  value?: string;
}

export interface EnterpriseSetting {
  enterpriseUnitId: string;
  configurationSetId: { name?: string };
  configurationSettings: ConfigurationSetting[];
}
export interface SiteResponse {
  address?: Address;
  contact?: Contact;
  coordinates: Coordinates;
  createdOn?: string;
  currency?: string;
  customAttributeSets?: CustomAttributeSet[];
  dayparts?: DayPart[];
  deactivatedOn?: string;
  description?: string;
  enterpriseSettings?: EnterpriseSetting[];
  enterpriseUnitName: string;
  hours?: Hours[];
  id?: string;
  lastModifiedOn?: string;
  locked?: boolean;
  parentEnterpriseUnitId?: string;
  referenceId?: string;
  siteName: string;
  status: Status;
  timeZone?: string;
}

export interface FilterSiteResponseContent
  extends Omit<SiteResponse, 'createdOn' | 'deactivatedOn' | 'enterpriseSettings' | 'lastModifiedOn'> {
  groups?: string[];
}
